var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetirement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.626 24H124a20 20 0 00-20 20 20 20 0 0020 20h4L72 168h40v104h80v32h76.564L296 264v-48l17.256-138.046A48 48 0 00265.626 24z",
    fill: "#ffdad2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280 304l-40 192H16a170.088 170.088 0 0174.896-124.597L192 304z",
    fill: "#3086cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144 336l-8.103 11.576A518.758 518.758 0 0064 496h176l40-192h-88z",
    fill: "#4db7e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 64h-68a20 20 0 01-20-20 20 20 0 0120-20h141.626a48 48 0 0147.63 53.954L296 216l-40-48 16-32-40-16-40 48z",
    fill: "#adcee8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192 304h83.646L240 360z",
    fill: "#47a2d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M296 264a573.672 573.672 0 00-99.485 212.81L192 496h296V368a234.958 234.958 0 00-125.081-85.411z",
    fill: "#2a70ab"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192 304l-48 32 8 32 24 8 41.846-41.846z",
    fill: "#3086cd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168 496l8-120-24-8-25.6 128z",
    fill: "#2a70ab"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312 440V268.444L296 264a573.667 573.667 0 00-99.485 212.81L192 496h72l-16-24z",
    fill: "#3086cd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.93 213.018a15.33 15.33 0 009.426-22.758A45.849 45.849 0 00126.041 168H112v32h24l2.501 5.001a15.328 15.328 0 0017.428 8.017zM112 224l16 16h96l-32 32h-80z",
    fill: "#adcee8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#6b402a",
    height: 16,
    rx: 8,
    width: 32,
    x: 128,
    y: 112
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M192 294.627l59.313-59.313A8 8 0 00240 224l-48 48z",
    fill: "#ff9f9b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M344.26 200.782L360 248h64l15.74-47.218a8.16 8.16 0 00-12.638-9.109v.001a16 16 0 01-20.914-1.486l-8.418-8.418a8.16 8.16 0 00-11.54 0l-8.418 8.418a16 16 0 01-20.913 1.486h-.001a8.16 8.16 0 00-12.637 9.108z",
    fill: "#f35244"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M400 248h-16v-24a8 8 0 018-8 8 8 0 018 8z",
    fill: "#cf3b2e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360 280h64a64 64 0 0164 64v104a40 40 0 01-40 40H336a40 40 0 01-40-40V344a64 64 0 0164-64z",
    fill: "#ea4a3b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M360 248h64v32h-64z",
    fill: "#db4132"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280 360h144v80H280z",
    fill: "#95cb37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#69a709"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 400a40 40 0 0040-40h-40zM320 440a40 40 0 00-40-40v40zM424 400a40 40 0 01-40-40h40zM384 440a40 40 0 0140-40v40z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280 440h144v48H280z",
    fill: "#448703"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M405.21 440A47.976 47.976 0 01360 472h-80v16h144v-48z",
    fill: "#276b02"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336 360h32v128h-32z",
    fill: "#fca713"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M336 440h32v48h-32z",
    fill: "#f98500"
  })));
}

export default __webpack_public_path__ + "4373bce34d5588c6b89f8c36f17c1765.svg";
export { SvgRetirement as ReactComponent };